export const SCALE_UNITS = ["cm", "mm", "μm", "nm", "Å", "pm"];